import { api } from "@services/baseURL";

export const SaveSolicitacao = async (data) => {
    try {
        const response = await api.post('Solicitacao', data);
        return response.data;
    } catch (error) {
        console.error('Erro ao salvar solicitação:', error);
        throw error;
    }
};

export const UpdateSolicitacao = async (id, data) => {
    try {
        const response = await api.patch(`Solicitacao/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar solicitação:', error);
        throw error;
    }
};

// Método para o auditor enviar uma solicitação
export const SendSolicitacao = async (id) => {
    try {
        const response = await api.post(`Solicitacao/send/${id}`);
        return response.data;
    } catch (error) {
        console.error('Erro ao enviar a solicitação:', error);
        throw error;
    }
};

// Método para unidade/gerencia enviar a resposta solicitação
export const AnswerSolicitacao = async (id) => {
    try {
        const response = await api.post(`Solicitacao/answer/${id}`);
        return response.data;
    } catch (error) {
        console.error('Erro ao enviar a resposta da solicitação:', error);
        throw error;
    }
};

// Método para o auditor enviar um relatorio da solicitação
export const SendReportSolicitacao = async (id, idTemplateEmailRelatorio) => {
    try {
        const response = await api.post(`Solicitacao/send-report/${id}/${idTemplateEmailRelatorio}`);
        return response.data;
    } catch (error) {
        console.error('Erro ao enviar o relatório solicitação:', error);
        throw error;
    }
};

// Método para a unidade/gerencia enviar um plano de ação referente ao relatorio anexado pelo auditor
export const SendActionPlanSolicitacao = async (id) => {
    try {
        const response = await api.post(`Solicitacao/answer-action-plan/${id}`);
        return response.data;
    } catch (error) {
        console.error('Erro ao enviar o plano de ação solicitação:', error);
        throw error;
    }
};

// Método para o auditor finalizar a solicitação
export const FinishSolicitacao = async (id) => {
    try {
        const response = await api.post(`Solicitacao/finish/${id}`);
        return response.data;
    } catch (error) {
        console.error('Erro ao finalizar a solicitação:', error);
        throw error;
    }
};

export const DeleteSolicitacao = async (id) => {
    try {
        await api.delete(`Solicitacao/${id}`);
        return true;
    } catch (error) {
        console.error('Erro ao deletar solicitacao:', error);
        throw error;
    }
};

export const GetAllSolicitacoes = async (pageSize, rowsPerPage, filters = {}) => {
    try {
        const response = await api.get('Solicitacao', {
            headers: {
                Authorization: `Bearer authToken`,
            },
            params: {
                pageNumber: pageSize,
                pageSize: rowsPerPage,
                ...filters,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar todas solicitações:', error);
        throw error;
    }
};

export const GetAllSolicitacoesByUnidadeWithOptionalFilters = async (pageSize, rowsPerPage, idUnidadeGerencia, filters = {}) => {
    try {
        const response = await api.get(`Solicitacao/unidadeGerencia/optional-filters/${idUnidadeGerencia}`, {
            headers: {
                Authorization: `Bearer authToken`,
            },
            params: {
                pageNumber: pageSize,
                pageSize: rowsPerPage,
                ...filters
            },
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar todas solicitações:', error);
        throw error;
    }
};

export const GetAllSolicitacoesByUnidadeWithRequiredFilter = async (pageSize, rowsPerPage, idUnidadeGerencia) => {
    try {
        const response = await api.get(`Solicitacao/unidadeGerencia/required-filter/${idUnidadeGerencia}`, {
            headers: {
                Authorization: `Bearer authToken`,
            },
            params: {
                pageNumber: pageSize,
                pageSize: rowsPerPage,
            },
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar todas solicitações:', error);
        throw error;
    }
};

export const GetByIdSolicitacao = async (id) => {
    try {
        const response = await api.get(`Solicitacao/${id}`);
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar os dados da solicitacao pelo id:', error);
        throw error;
    }
};

export const GetByIdSolicitacaoParaVisualizacao = async (id) => {
    try {
        const response = await api.get(`Solicitacao/visitante/${id}`);
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar os dados da solicitacao pelo id:', error);
        throw error;
    }
};

export default {
    SaveSolicitacao,
    UpdateSolicitacao,
    SendSolicitacao,
    AnswerSolicitacao,
    SendReportSolicitacao,
    SendActionPlanSolicitacao,
    DeleteSolicitacao,
    GetByIdSolicitacao,
    GetByIdSolicitacaoParaVisualizacao,
    GetAllSolicitacoes,
};